const keyValueHeadersPattern =
  /^\s*[a-zA-Z0-9-_]+:\s*[a-zA-Z0-9\s\-_.,]+(?:\|\s*[a-zA-Z0-9-_]+:\s*[a-zA-Z0-9\s\-_.,]+)*\s*$/;

export const isValidCustomHeaders = (value) => {
  const headers = value?.trim();

  if (!headers || keyValueHeadersPattern.test(headers)) {
    return true;
  }

  try {
    const parsedHeaders = JSON.parse(headers);

    return (
      parsedHeaders !== null &&
      !Array.isArray(parsedHeaders) &&
      typeof parsedHeaders === 'object' &&
      Object.entries(parsedHeaders).every(
        ([key, headerValue]) =>
          key.trim().length > 0 && ['string', 'number', 'boolean'].includes(typeof headerValue)
      )
    );
  } catch {
    return false;
  }
};
